module.exports = __webpack_public_path__ + "img/valimail-defend-ejaf-technology.e96d46d3.png";